


const displayVideoList:any = [];
const uploadVideoList:any = [];
const gumVideo:any = '';

export const VideoService = {
    displayVideoList,
    uploadVideoList,
    gumVideo
  };